import { Select, type SelectProps } from '@mantine/core';
import { useMemo } from 'react';

export interface EnumSelectorProps<T extends Record<string, string | number>> extends Omit<SelectProps, 'data'> {
    enumObject: T;
    labelFormatter?: (key: string, value: string | number) => string;
}

// Generic select component that dynamically builds options from an enum
export const EnumSelector = <T extends Record<string, string | number>>({
    enumObject,
    labelFormatter,
    ...props
}: EnumSelectorProps<T>) => {
    const data = useMemo(() => {
        return Object.entries(enumObject).map(([key, value]) => ({
            value: String(value),
            label: labelFormatter ? labelFormatter(key, value) : key,
        }));
    }, [enumObject, labelFormatter]);

    return <Select size="xs" data={data} {...props} />;
};
